import {View, Text, StyleSheet} from 'react-native';
import {theme} from 'config/themes';
import {FileListItemLayout} from 'interface/stacks/FileListItem';

import type {ReactNode, MouseEvent} from 'react';
import type {FileListItemProps} from 'interface/stacks/FileListItem';

export interface FileListItemCellProps extends FileListItemProps {
  renderIcons?: () => ReactNode,
  renderThumbnail: () => ReactNode,
  onDropDownMenu: (e: MouseEvent) => void,
}

export function FileListItemCell(props: FileListItemCellProps) {
  // Determine name container width based on layout
  const isSmallGrid = props.layout === FileListItemLayout.GridSmall;
  const isMediumGrid = props.layout === FileListItemLayout.GridMedium;
  const isLargeGrid = props.layout === FileListItemLayout.GridLarge;
  
  const nameStyle = [
    styles.name,
    isSmallGrid && styles.nameSmall,
    isMediumGrid && styles.nameMedium,
    isLargeGrid && styles.nameLarge,
  ];
  
  return (
    <View style={styles.root}>
      <View style={styles.thumbnail}>
        {props.renderThumbnail()}
      </View>
      <View style={nameStyle}>
        <Text
          style={styles.title}
          ellipsizeMode="middle"
          lineBreakMode="middle"
          numberOfLines={2}>
          {props.item.name}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    width: '100%',
    overflow: 'hidden',
    padding: 6,
  },
  thumbnail: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  name: {
    marginTop: 8,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    width: '100%',
    overflow: 'hidden',
  },
  nameSmall: {
    maxWidth: 100,
  },
  nameMedium: {
    maxWidth: 140,
  },
  nameLarge: {
    maxWidth: 200,
  },
  title: {
    fontSize: 13,
    textAlign: 'center',
    color: theme.files.listItem.title,
    // wordBreak: 'break-word', TODO: WEB ONLY
  }
});
